"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "allergy-module eh-ds" };
var vue_3 = require("vue");
var AllergyForm_vue_1 = require("./AllergyForm.vue");
var AllergyList_vue_1 = require("./AllergyList.vue");
var allergyStore_1 = require("@/stores/allergyStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'AllergyModule',
    setup: function (__props) {
        (0, vue_3.onMounted)(function () {
            console.log("Stores Informaiton");
            var stores = (0, allergyStore_1.useAllergyStore)();
            console.log(stores.allergies);
            console.log(stores.allergies);
            console.log(stores.getbackendAllergies());
            try {
                stores.allergies;
            }
            catch (error) {
                console.error("Error fetching allergies:", error);
            }
            //stores.allergies;
        });
        var currentView = (0, vue_3.ref)('list');
        var editingAllergyId = (0, vue_3.ref)(null);
        function openAddForm() {
            editingAllergyId.value = null;
            currentView.value = 'form';
        }
        function openEditForm(id) {
            editingAllergyId.value = id;
            currentView.value = 'form';
        }
        function returnToList() {
            currentView.value = 'list';
            editingAllergyId.value = null;
        }
        function handleSaved(allergy) {
            currentView.value = 'list';
            editingAllergyId.value = null;
        }
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Suspense, null, {
                    default: (0, vue_2.withCtx)(function () { return [
                        (0, vue_2.createVNode)(vue_2.Transition, {
                            name: "slide",
                            mode: "out-in"
                        }, {
                            default: (0, vue_2.withCtx)(function () { return [
                                (currentView.value === 'list')
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(AllergyList_vue_1.default, {
                                        key: "list",
                                        onAdd: openAddForm,
                                        onEdit: openEditForm
                                    }))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(AllergyForm_vue_1.default, {
                                        key: "form",
                                        "allergy-id": editingAllergyId.value,
                                        onCancel: returnToList,
                                        onSaved: handleSaved
                                    }, null, 8, ["allergy-id"]))
                            ]; }, undefined, true),
                            _: 1
                        })
                    ]; }),
                    fallback: (0, vue_2.withCtx)(function () { return __spreadArray([], (_cache[0] || (_cache[0] = [
                        (0, vue_2.createElementVNode)("div", null, "Loading...", -1)
                    ])), true); }),
                    _: 1
                }))
            ]));
        };
    }
});
